import BoundariesTable from './BoundariesTable'

export default BoundariesTable
